export default __webpack_public_path__ + "static/media/hht2_ep14_timeline_q04_a.22a11e5b.png";